// extracted by mini-css-extract-plugin
export var aircallIframe = "_mc-3";
export var fabContainer = "_mc-5";
export var fabRinging = "_mc-6";
export var loadingOverlay = "_mc-4";
export var pulse = "_mc-7";
export var widgetContent = "_mc-2";
export var widgetPanel = "_mc-0";
export var widgetPanelExpanded = "_mc-1";